module.exports = __webpack_public_path__ + "img/img_cx1_open.9dc06d9b.jpg";